module.exports = __webpack_public_path__ + "assets/57d0f1e530df3f3fddc886681be042c0.svg";